
















































































import { Component } from 'vue-property-decorator';
import SheetHeader from '@/components/sheet/SheetHeader.vue';
import EventFlowStep from '@/model/enums/event-flow/event-flow-step';
import { EmailInvite, SheetWithItems } from '@/model/Sheet';
import { mapActions, mapGetters } from 'vuex';
import EventFlow from '@/active-components/event-flow/EventFlow.vue';
import CustomModal from '@/components/modal/CustomModal.vue';
import InviteFormSheet from '@/components/sheet/InviteFormSheet.vue';
import { mixins } from 'vue-class-component';
import ToastMixin from '@/mixins/ToastMixin';
import ToastVariant from '@/model/enums/toast/toast-variant';
import { ApiError } from '@/model/ApiError';
import EventFlowGrid from '@/components/event-flow/EventFlowGrid.vue';
import '@/lib/font/Jost-Regular-normal';
import { newnewPdf } from '@/lib/pdf-util';
import { getEnumValueByEnumKey } from '@/lib/helper/event-flow-helper';
import FormCheckbox from '@/components/form/FormCheckbox.vue';
import { ExtraFunctionFormData } from '@/model/event-flow/EventFlow';
import EventFlowLocationName from '@/components/event-flow/EventFlowLocationName.vue';
import EventFlowLocationHeader from '@/components/event-flow/EventFlowLocationHeader.vue';

@Component({
    components: {
        SheetHeader,
        EventFlow,
        CustomModal,
        InviteFormSheet,
        EventFlowGrid,
        FormCheckbox,
        EventFlowLocationName,
        EventFlowLocationHeader,
    },
    computed: {
        ...mapGetters({
            getCurrentSheetWithItems: 'sheetStorage/getCurrentSheetWithItems',
            getSheetFlow: 'sheetStorage/getSheetFlow',
            getError: 'sheetStorage/getError',
        }),
    },
    methods: {
        newnewPdf,
        ...mapActions({
            fetchCurrentSheetWithItems:
                'sheetStorage/fetchCurrentSheetWithItems',
            invite: 'sheetStorage/invite',
        }),
    },
})
export default class Sheet extends mixins(ToastMixin) {
    fetchCurrentSheetWithItems!: (
        token: string,
    ) => Promise<void | SheetWithItems>;

    invite!: (emailInvite: EmailInvite) => Promise<void>;

    getCurrentSheetWithItems!: SheetWithItems | null;

    getError!: ApiError;

    loading = true;

    token = this.$route.params.token;

    EventFlowStep!: EventFlowStep | null;

    extraFunctionFormData: ExtraFunctionFormData = {
        showTime: false,
        showBrief: false,
        showLegend: false,
    };

    mounted(): void {
        this.fetchCurrentSheetWithItems(this.token)
            .then(() => {
                document.title = `${this.getCurrentSheetWithItems?.name} - Cascade`;
            })
            .catch(() => {
                document.title = `${this.$t(
                    'event.not-found',
                ).toString()} - Cascade`;
            })
            .finally(() => {
                this.loading = false;
            });
    }

    onSubmit(email: string): void {
        if (this.getCurrentSheetWithItems?.id) {
            this.invite({
                email,
                sheetId: this.getCurrentSheetWithItems.id,
            }).then(() => {
                this.$bvModal.hide('invite-modal');
                this.showToast(
                    this.$t('invite.success').toString(),
                    this.$t('invite.title').toString(),
                    ToastVariant.SUCCESS,
                );
            });
        }
    }

    get getStep(): number {
        return parseInt(
            getEnumValueByEnumKey(
                EventFlowStep,
                this.getCurrentSheetWithItems?.step,
            ) as string,
            10,
        );
    }

    close(): void {
        this.$bvModal.hide('invite-modal');
    }
}
